import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { heroCopy } from '@/mocks/hero';

gsap.registerPlugin(ScrollTrigger);

export default function HeroNav() {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const first = document.querySelector('main > :nth-child(2)');
    if (!first) return undefined;
    const st = ScrollTrigger.create({
      trigger: first,
      start: 'top 72px',
      end: 'max',
      onToggle: (self) => setSolid(self.isActive),
    });
    return () => st.kill();
  }, []);

  const linkTone = solid ? 'text-foreground-700 hover:text-primary-600' : 'text-background-200/80 hover:text-background-50';

  return createPortal(
    <header
      className={`wp-ui-fade fixed inset-x-0 top-0 z-50 px-4 md:px-10 transition-[background-color,border-color,padding] duration-500 border-b ${solid ? 'py-3.5 bg-background-50/95 backdrop-blur-md border-background-200/70' : 'py-5 bg-transparent border-transparent'}`}
    >
      <nav className={`flex items-center justify-between gap-6 transition-colors duration-500 ${solid ? 'text-foreground-950' : 'text-background-100'}`}>
        <a href="#top" className="flex items-baseline gap-2 cursor-pointer">
          <span className="font-heading text-xl tracking-tight">{heroCopy.brand}</span>
          <span className={`hidden sm:inline text-[11px] uppercase tracking-[0.2em] ${solid ? 'text-foreground-500' : 'text-background-300/80'}`}>{heroCopy.brandSub}</span>
        </a>
        <ul className="hidden md:flex items-center gap-8 text-[13px]">
          {heroCopy.nav.map((n) => (
            <li key={n.href}><a href={n.href} className={`whitespace-nowrap transition-colors cursor-pointer ${linkTone}`}>{n.label}</a></li>
          ))}
        </ul>
        <div className="flex items-center gap-3">
          <a href={`tel:${heroCopy.phone}`} className={`hidden lg:inline whitespace-nowrap text-[13px] ${solid ? 'text-foreground-600' : 'text-background-200/80'}`}>{heroCopy.phone}</a>
          <a href={heroCopy.ctaHref} className={`hidden md:inline-flex whitespace-nowrap rounded-full border px-4 py-1.5 text-[13px] transition-colors cursor-pointer ${solid ? 'border-foreground-950/25 hover:bg-foreground-950/5' : 'border-background-50/30 hover:bg-background-50/10'}`}>{heroCopy.compactCta}</a>
          <button type="button" aria-label="Menu" onClick={() => setOpen((v) => !v)} className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer whitespace-nowrap">
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </nav>
      {open && (
        <ul className="md:hidden mt-4 flex flex-col gap-3 rounded-lg bg-foreground-950/90 p-4 text-sm text-background-100">
          {heroCopy.nav.map((n) => (
            <li key={n.href}><a href={n.href} onClick={() => setOpen(false)} className="cursor-pointer">{n.label}</a></li>
          ))}
          <li><a href={heroCopy.ctaHref} onClick={() => setOpen(false)} className="cursor-pointer text-accent-300">{heroCopy.cta}</a></li>
        </ul>
      )}
    </header>,
    document.body,
  );
}